module.exports = __webpack_public_path__ + "img/topgps_bg.ca7e79c8.png";